import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { accTypeMapModel, accTypeModel, ChartAccModel, customTypeModel, JournalSearchChartAccModel } from 'src/app/models/Accounting/tChartAccModel';
import { currencyModel } from 'src/app/models/Accounting/tCurrencyModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { AppSettings } from 'src/app/shared/AppSettings';

@Injectable({
  providedIn: 'root'
})
export class  ChartAccService {

  constructor(private http: HttpClient) {

  }

  baseurl: string = AppSettings.BaseURI;

  readonly pathChartAcc = '/tChartAccModels';
  readonly pathAccType = '/tAccType';
  readonly pathAccSubType = '/tAccSubType';
  readonly pathAccSubTypeMap = '/tAccSubTypeMap';

  getAllData(item:object) {
    return this.http.post<ChartAccModel[]>(this.baseurl + this.pathChartAcc + '/search/'+NavigationComponent.selectedShopID.toString(), item );
  }

  journalSearchChart(item:object) {
    return this.http.post<JournalSearchChartAccModel[]>(this.baseurl + this.pathChartAcc + '/journalSearchChart/'+NavigationComponent.selectedShopID.toString() , item );
  }

  journalSearchChartvoucher() {
    return this.http.get<JournalSearchChartAccModel[]>(this.baseurl + this.pathChartAcc + '/journalSearchChartvoucher');
  }


  getAccSubType() {
    return this.http.get<customTypeModel[]>(this.baseurl + this.pathAccType + '/');

  }

  getAccType() {
    return this.http.get<accTypeModel[]>(this.baseurl + this.pathAccType + '/');

  }

  getAccTypeByAccType(value:number){
    return this.http.get<[]>(this.baseurl + this.pathChartAcc + '/typeByAccType/' + value+'/'+NavigationComponent.selectedShopID.toString());

  }

  getAccTypeAndSubType() {

    return this.http.get<accTypeMapModel[]>(this.baseurl + this.pathAccSubTypeMap);

  }

  postChartAcc(data: object) {
    return this.http.post<object>(this.baseurl + this.pathChartAcc, data);

  }

  getChartAccByAccCode(accCode:string){
    return this.http.get<object>(this.baseurl + this.pathChartAcc + '/edit/' + accCode);

  }

  update(orgAccCode:string , data:object){
    return this.http.put<object>(this.baseurl + this.pathChartAcc + '/edit/' + orgAccCode , data);

  }
  
  delete(accCode:string){
    return this.http.delete(this.baseurl + this.pathChartAcc + '/'+ accCode+'/'+NavigationComponent.selectedShopID.toString());

  }

}
